module.exports = "/images/trail-4.jpg";